import type { DrawerState } from "@WahooFitness/redesignr";
import type { PropsWithChildren } from "react";
import CancelConfirmationContent from "./CancelConfirmationContent";

type DrawerParams = PropsWithChildren<Partial<DrawerState>>;

type CancelConfirmationDrawerParams = {
  tierLabel: string;
  downgradeTierLabel: string;
  accessUntilLabel?: string;
  onKeepPlan: () => void;
  onCancelPlan: () => Promise<unknown>;
  onDismiss: () => void;
};

export function buildCancelConfirmationDrawer({
  tierLabel,
  downgradeTierLabel,
  accessUntilLabel,
  onKeepPlan,
  onCancelPlan,
  onDismiss,
}: CancelConfirmationDrawerParams): DrawerParams {
  return {
    open: true,
    hidePuller: true,
    hideDivider: true,
    title: undefined,
    logDismissEvent: onDismiss,
    children: (
      <CancelConfirmationContent
        tierLabel={tierLabel}
        downgradeTierLabel={downgradeTierLabel}
        accessUntilLabel={accessUntilLabel}
        onKeepPlan={onKeepPlan}
        onCancelPlan={onCancelPlan}
      />
    ),
  };
}
